// Small gap between the container top and the project header after scrolling.
const DEFAULT_OFFSET_PX = 16;

/**
 * Smooth-scrolls the Projects page to a project's anchor element
 * (`id="project-<name>"`), rendered by both the Cards view (ProjectGroup)
 * and the List view (GroupedFlatTableView).
 *
 * The app layout scrolls inside the `.spark-native-scrollbar` Layout — the
 * window itself never scrolls (the outer Layout is `overflow: hidden`) — so
 * we scroll that container instead of `window`. Falls back to `window` in
 * case the anchor is ever rendered outside that container.
 *
 * Returns true when the anchor was found and a scroll was initiated.
 */
export function scrollToProjectAnchor(projectName, { offset = DEFAULT_OFFSET_PX } = {}) {
    const el = document.getElementById(`project-${projectName}`);
    if (!el) return false;

    const container = el.closest('.spark-native-scrollbar');
    if (container) {
        const top =
            container.scrollTop +
            el.getBoundingClientRect().top -
            container.getBoundingClientRect().top -
            offset;
        container.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    } else {
        const top = el.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
    }
    return true;
}
